import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { deleteBillingProvider } from 'api/Admin/Practice/Providers';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

const Actions = ({ data }) => {
  const [deleteModal, setDeleteModal] = useState(null);

  const { setShowModal, setSelectedItem } = useTableContext();
  const navigate = useNavigate();

  const mutateDeleteBillingProvider = useCustomMutation({
    mutationFn: () => deleteBillingProvider(navigate, { id: data?.id }),
    invalidateQueryKey: ['billing-provider'],
    successMessage: 'Billing Provider deleted successfully'
  });

  const actionOptions = [
    {
      label: 'Delete',
      icon: 'trash-mono',
      onClick: () => {
        setDeleteModal(true);
      }
    },
    {
      label: 'Edit',
      icon: 'edit-2-mono',
      onClick: () => {
        setSelectedItem(data);
        setShowModal(true);
      }
    }
  ];

  return (
    <>
      <Popover
        isFixed
        position="left"
        isBorder={false}
        options={actionOptions}
        className="flex h-full items-center"
      />
      {!!deleteModal && (
        <Confirm
          isOpen={deleteModal}
          title={`Delete Billing Provider ${data?.id}`}
          message="Are you sure you want to delete this billing provider?"
          variant="danger"
          icon="trash-mono"
          handleClose={() => setDeleteModal(false)}
          footerActions={{
            primary: {
              text: 'Delete',
              onClick: () => mutateDeleteBillingProvider.mutate(),
              color: 'danger',
              isLoading: mutateDeleteBillingProvider.isLoading
            }
          }}
        />
      )}
    </>
  );
};

export default withErrorBoundary(Actions);
